module.exports = __webpack_public_path__ + "static/mindsea-logo-18dd95c51d79723736908df4eb7f20fd.png";